import React, { useState, useEffect } from "react";
import {
  Drawer,
  Button,
  Form,
  Input,
  Row,
  Col,
  notification,
  Space,
  Typography,
  Flex,
  Select,
  TreeSelect,
  Dropdown
} from "antd";
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  DownOutlined,
  ShrinkOutlined,
  ExpandOutlined,
  ExportOutlined
} from "@ant-design/icons";
import UploadButton from "../common/UploadButton";
import globalData from "../../config/global_data";
import ErrorNotification from "../common/ErrorNotification";
import StatusBadge from "../common/StatusBadge";
import ProductDetails from "../common/ProductDetails";
import common_api from "../../config/common_api";
import CommonAttributeList from "../common/CommonAttributeList";
import { triggerNotification } from "../common/notify";
import { useAuth } from "../UserAuth/AuthContext";


const { Text } = Typography;

const ButtonItems = [
  {
    label: 'Save as Draft',
    key: 'saveDraft',
  },
  {
    label: 'Save & Reload',
    key: 'saveReload',
  },
];

const SimpleDrawer = ({ visible, onClose, selected_prod_data, setisloader, onProductCreate, globalList, setGlobalList }) => {
  const [form] = Form.useForm();
  const [treeData, setTreeData] = useState(null)
  const [bundleTitle, setBundleTitle] = useState("New Simple Product");
  const [selectedSku, setSelectedSku] = useState(null);
  const [imageObj, setImageObj] = useState(null);
  const [savedimages, setSavedimgaes] = useState(null);
  const [savedattributes, setSavedattributes] = useState(null);
  const [removedValues, setRemovedValues] = useState(null);
  const [selectedValues, setSelectedValues] = React.useState([]);
  const [data, setData] = useState(selected_prod_data);
  const [alert, setAlert] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [isGift, setIsGift] = useState(null);
  const { userData } = useAuth();
  const [hasAttributeError, setHasAttributeError] = useState(false);
  const onChange = (values) => {
    setSelectedValues(values);
  };

  const handleMenuClick = ({ key }) => {
    form
      .validateFields()
      .then((values) => {
        if (key === 'save') {
          onClose(); // Replace with your actual save logic
        }
      })
      .catch(() => {
        openNotification();
      });
  };

  const handleSaveAndPublishClick = () => {
    if (hasAttributeError) {
      triggerNotification({
        type: 'error',
        title: 'Attribute Error!',
        message: 'Please fix all errors before saving.'
      });
      return;
    }
    form
      .validateFields()
      .then((values) => {
        handleSaveAndPublish(values);
      })
      .catch(() => {
        openNotification();
      });
  };
  useEffect(() => {
    const fetchData = async () => {
      if (globalData && globalData.all_cat_list && globalData.all_cat_list.length > 0) {
        let cattree = await globalData.all_cat_list.filter(item => item.store_id === selected_prod_data.store_id)
        if (cattree && cattree.length > 0) {
          setTreeData(cattree[0].treedata)
        }
      }
      // let apitreedata = await api.get_category_tree(selected_prod_data.store_id)
      // setTreeData(apitreedata)      
      let giftratio = 0
      if (data.bc_name && data.bcSku.toUpperCase().includes("GIFT")) {
        if (data.prdouct_data && data.prdouct_data.custom_fields.length > 0) {
          let is_exist = data.prdouct_data.custom_fields.find(item => item.name === "Inventory_Ratio")
          if (is_exist) {
            giftratio = is_exist.value
            setIsGift(is_exist)
          } else {
            setIsGift({ name: "Inventory_Ratio", value: 0 })
          }
        }
      }
      form.setFieldsValue({
        msrpPrice: data.prdouct_data?.prod_msrp,
        salePrice: data.prdouct_data?.prod_sale_price,
        SAPmsrp: data.sapMsrp,
        SAPPrice: data.sapPrice,
        pname: data.bc_name ? data.bc_name : data.sapName,
        sap_sku_select: data.sapSku,
        status: data.active,
        inventorySplit: giftratio
      });
      if (selected_prod_data.prdouct_data && selected_prod_data.prdouct_data.categories.length > 0) {
        const categoriesStringArray = selected_prod_data.prdouct_data.categories.map(String);

        setSelectedValues(categoriesStringArray)

      } else {
        setSelectedValues([])
      }
    }

    // let cat_tree= await api.get_category_tree()
    if (selected_prod_data && visible) {
      fetchData()
      setData(selected_prod_data);
      let main_prod_name = selected_prod_data.bc_name ? selected_prod_data.bc_name : selected_prod_data.sapName
      setBundleTitle(main_prod_name || "New Simple Product");
      if (selected_prod_data.prdouct_data && selected_prod_data.prdouct_data.images) {
        setImageObj({ img_data: selected_prod_data.prdouct_data.images })
      }
    }
  }, [selected_prod_data, visible, selectedSku]);

  const handleInputChange = (name) => (e) => {
    const value = e.target.value.replace(/[^\d]/g, '');
    form.setFieldsValue({ [name]: value });
  };
  const handleSaveAndPublish = async (values) => {

    // return 1
    let images = []
    let available_images = selected_prod_data.prdouct_data.images
    if (savedimages.image_data && savedimages.image_data.length > 0) {
      images = await savedimages.image_data.map(item => {
        if (item.is_saved) {
          return {
            id: item.is_saved,
            url_standard: item.thumbUrl,
            is_thumbnail: item.set_as_Featured,
            sort_order: item.img_order
          }
        } else {
          return {
            image_url: item.thumbUrl
          }
        }
      })
    }
    const currentImageUrls = new Set(
      (savedimages.image_data || []).map(item => item.thumbUrl)
    );
    const deletedImages = (available_images || [])
      .filter(img => !currentImageUrls.has(img.url_standard))
      .map(img => img.id);

    let custom_fields_final = [], custom_fields_removed = [];
    if (savedattributes.custom_fields && savedattributes.custom_fields.length > 0) {
      const data = savedattributes.custom_fields;
      data.forEach(attr => {
        const { values, attribute_key, max_size } = attr;

        let baseKey = attribute_key
        let counter = 1;

        values.forEach((item, index) => {
          if (item.val) {
            let itemobj = {}
            if (baseKey.includes("NUM")) {
              itemobj = {
                "id": item.key,
                "name": baseKey.replace("NUM", counter),
                "value": item.val
              }
            } else if (max_size === 1) {
              itemobj = {
                "id": item.key,
                "name": baseKey,
                "value": item.val
              }
            }
            else {
              itemobj = {
                "id": item.key,
                "name": baseKey + "_" + counter,
                "value": item.val
              }
            }
            if (itemobj.id === "") {
              delete itemobj.id
            }
            custom_fields_final.push(itemobj)
            counter++;
          }
        });
      });

    }
    if (removedValues && removedValues.custom_fields && removedValues.custom_fields.length > 0) {
      custom_fields_removed = removedValues.custom_fields
    }
    if (isGift) {
      isGift.value = values.inventorySplit
      custom_fields_final.push(isGift)
    }
    let req_data = {
      "store_id": data.store_id,
      "sku": data.bcSku,
      "store": data.store,
      "product_id": data.prod_id,
      "bcInventory": data.bcInventory,
      "data": {
        "name": values.pname,
        "sku": values.bcSku,
        "price": values.msrpPrice.replace(data.currency_symbol, ""),
        "sale_price": values.salePrice.replace(data.currency_symbol, ""),
        "images": images && images.length > 0 ? images : [],
        "custom_fields": custom_fields_final,
        "categories": selectedValues
      },
      custom_fields_removed,
      images_removed: deletedImages
    }

    setisloader(true)
    let responsedata = await common_api.update_product(req_data)
    if (responsedata) {      
      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
      if (alldata) {
        await setGlobalList(alldata)
      }
      setisloader(true)

      triggerNotification(responsedata)

    }

    setisloader(false)
    onClose()
  }

  const openNotification = () => {
    triggerNotification({
      type: 'error',
      title: 'Form incomplete!',
      message: "Please fix all errors before saving.",
    });
  };
  const SAPSKU_options_handleChange = (value) => {
    setSelectedSku(value);
  };
  const handleBlur = () => {
    const bundleName = form.getFieldValue("pname");
    if (bundleName && bundleName.trim() !== "") {
      setBundleTitle(bundleName.trim());
    } else {
      // Revert to original name from selected_prod_data
      const originalName = selected_prod_data.bc_name || selected_prod_data.sapName || "New Simple Product";
      setBundleTitle(originalName);
    }
  };


  const SAPSKU_options = [{
    value: data.bcSku,
    label: data.bcSku,
  }];

  return (
    <Drawer className={`DrawerBox ${isExpanded ? "DrawerBoxExpanded" : ""}`}
      title={bundleTitle}
      width={isExpanded ? 'calc(100% - 256px)' : 600}
      onClose={onClose}
      open={visible}
      extra={
        <>
          <div className="DrawerButtonBox">
            {data.active == true && selected_prod_data.bc_url !== "" && (
              <a href={selected_prod_data.bc_url ? selected_prod_data.bc_url : ""} target="_blank" title="View on Storefront" style={{ marginRight: 8 }} className="ViewPage" rel="noopener noreferrer">
                <ExportOutlined className="ViewPageIcon" style={{ fontSize: 16, color: 'rgba(0,0,0,0.88)' }} />
              </a>
            )}
            <Button
              className="ExpandDrawer"
              onClick={() => setIsExpanded(!isExpanded)}
              style={{ marginRight: 8 }}
            >
              {isExpanded ? <ShrinkOutlined /> : <ExpandOutlined />}
            </Button>           
            <ErrorNotification {...alert} />
            {userData?.data?.access === "ALL" && (
              <Dropdown.Button
                type="primary"
                icon={<DownOutlined />}
                menu={{
                  items: ButtonItems,
                  onClick: handleMenuClick,
                }}
                trigger={['click']}
                onClick={handleSaveAndPublishClick}
                style={{ marginLeft: 8 }}
              >
                Save & Publish
              </Dropdown.Button>
            )}
          </div>
        </>
      }
    >
      <Form layout="vertical" form={form}>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="DraftBox">
            <StatusBadge
              status={data.active}
              lastEdited={data.lastUpdated}
            />
          </div>
          <Space size="small" align="center">
            <Text strong>Product Details</Text>
          </Space>
          <ProductDetails
            productName={bundleTitle}
            sku={data.bcSku}
            msrp={data.currency_symbol + '' + data.prdouct_data?.prod_msrp}
            salePrice={data.currency_symbol + '' + data.prdouct_data?.prod_sale_price}
            isExpanded={isExpanded}
          />

        </div>

        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexName" : ""}`}>
          <Form.Item
            className="ExpandedFlexProductName"
            name="pname"
            rules={[{ required: true, whitespace: true, message: "Please enter Product name" }]}
            label={
              <span>
                Product Name&nbsp;              
              </span>
            }
          >
            <Input placeholder="Enter a Product Name" onChange={handleBlur} value={bundleTitle} maxLength={150}/>
          </Form.Item>
          <Flex className="flexbox">
            <Form.Item label={
              <span>
                Store&nbsp;                
              </span>} className="disabledstore">
              <Input placeholder="US" value={data.store} disabled />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  SAP SKU&nbsp;
                  
                </span>
              }
              className="sap_sku_select"
            >
              <Select
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Select SAP SKU"
                value={data.sapSku}
                onChange={SAPSKU_options_handleChange}
                options={SAPSKU_options}
                disabled
              />
            </Form.Item>

          </Flex>
        </div>
        {isGift && (
          <Form.Item
            label={
              <span>
                % Inventory split&nbsp;
                
              </span>
            }
            name="inventorySplit"
            rules={[
              { required: true, message: "Please enter the Inventory split" },
              {
                validator: (_, value) => {
                  if (value && parseFloat(value) > 100) {
                    return Promise.reject("Inventory split % cannot be more than 100.");
                  }
                  return Promise.resolve();
                }
              }
            ]}
          >
            <Input
              placeholder="Enter Inventory split %" type="number" addonAfter="%"
            />
          </Form.Item>
        )}
        <Form.Item
          label={
            <span>
              Product Categories&nbsp;
             
            </span>
          }

          rules={[{ required: true, message: "Please select at least one category" }]}
        >
          <TreeSelect
            className="CategoryTree"
            multiple
            treeData={treeData}
            value={selectedValues}
            onChange={onChange}
            placeholder="Select categories"
            showSearch
            treeDefaultExpandAll
            treeNodeFilterProp="title"
          />
        </Form.Item>
        <div className={`FlexItemBox ${isExpanded ? "ExpandedFlexRow" : ""}`}>
          <Row gutter={8} className="ExpandedFlexRowInner">
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store MSRP&nbsp;
                   
                  </span>
                }
                name="msrpPrice"
                rules={[
                  { required: true, message: "Please enter the Store MSRP" },
                ]}
              >
                <Input
                  placeholder="Enter MSRP"
                  prefix={data.currency_symbol}
                  onChange={handleInputChange("msrpPrice")}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store Sale Price&nbsp;                    
                  </span>
                }
                name="salePrice"
                rules={[
                  { required: true, message: "Please enter the sale price" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const msrp = parseFloat(getFieldValue('msrpPrice'));
                      const sale = parseFloat(value);
                      if (!value || isNaN(msrp) || isNaN(sale) || sale <= msrp) {
                        return Promise.resolve();
                      }
                      return Promise.reject('Sale Price cannot be greater than MSRP');
                    },
                  }),
                ]}
              >
                <Input placeholder="Enter Sale Price" prefix={data.currency_symbol}
                  onChange={handleInputChange("salePrice")} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8} className="ExpandedFlexRowInner">
            <Col span={12}>
              <Form.Item
                label="SAP MSRP"
                name="SAPmsrp"
                initialValue="100"
              >
                <Input placeholder="Enter MSRP" disabled />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="SAP Price"
                name="SAPPrice"
                initialValue="345"
              >
                <Input placeholder="Enter Sale Price" disabled />
              </Form.Item>
            </Col>
          </Row>
        </div>
        {visible && data && <Form.Item
          label={
            <span>
              PDP Gallery&nbsp;             
            </span>
          }
        >
          <UploadButton
            setSavedimgaes={setSavedimgaes}
            product_obj={imageObj}
            MAX_UPLOADS="50"
            delete="true"
            replace="true"
            thumbnail="true"
            hover=""
          />
        </Form.Item>}
        <div className="ProductDetailBox">
          <div className={`ProductDetailBox_inner FlexItemBox ${isExpanded ? "ExpandedAttributes" : ""}`}>
            {visible && <CommonAttributeList setRemovedValues={setRemovedValues} setSavedattributes={setSavedattributes} customfielddata={data} setHasAttributeError={setHasAttributeError} />}
          </div>
        </div>

      </Form>
    </Drawer>
  );
};

export default SimpleDrawer;
